// Translations for FounderBadge — official "Sauberino · Founder" mark on Tigik News posts.
// Used by components/FounderBadge.jsx.

const FOUNDER_TR = {
  sk: {
    label: "ZAKLADATEĽ",
    sub: "Sauberino",
    tooltip: "Oficiálny oznam od zakladateľa Tigik · Martin „Sauberino\" Smrkta",
  },
  en: {
    label: "FOUNDER",
    sub: "Sauberino",
    tooltip: "Official announcement from the founder of Tigik · Martin „Sauberino\" Smrkta",
  },
  cs: {
    label: "ZAKLADATEL",
    sub: "Sauberino",
    tooltip: "Oficiální oznámení od zakladatele Tigik · Martin „Sauberino\" Smrkta",
  },
  de: {
    label: "GRÜNDER",
    sub: "Sauberino",
    tooltip: "Offizielle Ankündigung vom Gründer von Tigik · Martin „Sauberino\" Smrkta",
  },
  pl: {
    label: "ZAŁOŻYCIEL",
    sub: "Sauberino",
    tooltip: "Oficjalne ogłoszenie od założyciela Tigik · Martin „Sauberino\" Smrkta",
  },
  fr: {
    label: "FONDATEUR",
    sub: "Sauberino",
    tooltip: "Annonce officielle du fondateur de Tigik · Martin « Sauberino » Smrkta",
  },
};

export default FOUNDER_TR;
